import * as React from "react";

import { CreateExperimentButton } from "@v1/features/experiments/components/CreateExperimentButton";

const ExperimentsSetup = () => {
  return (
    <div className="flex h-[70vh] items-center justify-center">
      <div className="flex flex-col items-center justify-center gap-4">
        <img
          src="/images/experiments/all-experiments-no-data.svg"
          alt="Experiments Overview"
          width={450}
        />
        <div className="header-h5">Test your ideas, see what converts.</div>
        <div className="text-muted max-w-[400px] text-center text-sm">
          Run simple A/B tests by splitting traffic to different pages. Discover
          the winner and improve store performance.
        </div>
        <CreateExperimentButton />
      </div>
    </div>
  );
};

export default ExperimentsSetup;
